import { render, staticRenderFns } from "./PlaylistsView.vue?vue&type=template&id=4da6eac3&scoped=true&"
import script from "./PlaylistsView.vue?vue&type=script&lang=js&"
export * from "./PlaylistsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6eac3",
  null
  
)

export default component.exports